import * as api from '@/service/index'
import { applyApiEnvFromConfig } from '@/service/index'
import { useBusinessStore, useStageStore } from '@/store'

// 加载远程 config 并同步到 store
// 需在 router.isReady() 之前触发 (main.js), 让路由守卫的 await stageStore.whenReady() 有信号可等
// 无论成功/失败都会调 syncEventStage() 释放 whenReady 等待, 决不 hang
export const loadAppConfig = async () => {
  const businessStore = useBusinessStore()
  const stageStore = useStageStore()
  let response
  try {
    response = await api.reqConfig()
    if (response.status === 200) {
      // 先应用 API 环境覆盖, 后续 store 里可能触发的 API 请求就能走正确 domain
      applyApiEnvFromConfig(response.data)
      businessStore.setConfig(response.data)
      stageStore.syncEventStage(response.data)
    }
  } finally {
    if (!stageStore.stageReady) stageStore.syncEventStage()
  }
  return response
}
